const OnlineStatus = (props) => {
  const onlineStatus = props?.row?.original.onlineStatus;

  return (
    <div className="online-status--signal">
      <b className={`online-status--signal--status ${onlineStatus ? "open" : "close"}`}></b>
    </div>
  );
};

export default OnlineStatus;
